<template>
  <div class="navbar">
    <div class="row justify-content-betweeen align-items-center w-100">
      <div class="card organization-card d-md-block d-sm-block d-lg-none">
        <div v-if="account.organization" class="card-body">
          <div class="row">
            <!-- <div class="col-2">
              <font-awesome-icon icon="fa-solid fa-building-circle-check" class="fa fa-large text-secondary" />
            </div> -->
            <div class="col-10" style="padding-left: 10px">
              <h6 class="name">{{ account.organization.name }}</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="navbar-right-section ml-auto">
        <router-link :to="helpRoute" class="btn-help">
          <font-awesome-icon icon="fa-regular fa-circle-question d-none d-lg-inline" class="fa" />
          <span class="d-lg-inline">Help</span>
        </router-link>
        <notificationBell v-if="chatEnabled" />
        <div class="dropdown dropleft navbar-avatar-dropdown">
          <div class="avatar-caret-container dropdown-toggle">
            <div
              class="avatar dropdown-toggle"
              type="button"
              data-toggle="dropdown"
            >
            {{ $filters.capitalizedFirstLetter(account.fname) }}
          </div>
          <font-awesome-icon icon="fa-solid fa-caret-down" class="fa" />
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <router-link :to="{ name: PROFILE_GENERAL_ROUTE, params: { id: account.id } }" class="dropdown-item">
              Profile
            </router-link>
            <router-link
              v-if="isAdmin"
              :to="{ name: GENERAL_SETTINGS_ROUTE }"
              class="dropdown-item"
            >
              Settings
            </router-link>
            <router-link
              :to="helpRoute"
              class="dropdown-item"
            >
              Help
            </router-link>
            <a v-on:click="logout()" class="dropdown-item final-item text-danger"
              >Log out</a
            >
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { PROFILE_GENERAL_ROUTE, GENERAL_SETTINGS_ROUTE, HELP_CENTER_ROUTE } from '@/router/routes';
import { SIGN_OUT } from '@/store/action_types';
import { isAdminRole } from '@/utils/roles';
import { PlatformModule } from '@/utils/enums';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCaretDown
} from '@fortawesome/free-solid-svg-icons';
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';
library.add(
  faCaretDown,
  faCircleQuestion
);
import { usePostHog } from '@/composables/posthog';
import notificationBell from '@/components/chat/Notification_Bell.vue';

const { posthog } = usePostHog();

export default {
  components: { notificationBell },
  data() {
    return {
      PROFILE_GENERAL_ROUTE,
      GENERAL_SETTINGS_ROUTE,
      HELP_CENTER_ROUTE,
    };
  },
  computed: {
    route() {
      return this.$route.name;
    },
    /** Opens the help center; the page name lets it suggest the guides for the current screen. */
    helpRoute() {
      const from = this.$route.name;
      return from && from !== HELP_CENTER_ROUTE ? { name: HELP_CENTER_ROUTE, query: { from } } : { name: HELP_CENTER_ROUTE };
    },
    account() {
      return this.$store.getters.account.data;
    },
    isAdmin() {
      return isAdminRole(this.account?.role);
    },
    /** The bell belongs to the chat module; without the licence there is nothing to notify about. */
    chatEnabled() {
      return this.$store.getters.enabledModules.includes(PlatformModule.chat);
    },
  },
  methods: {
    logout() {
      this.$store.dispatch(SIGN_OUT).then(async (res) => {
        posthog.identify(this.account.id, {
          employeeEmail: this.account.email,
          employeeName: `${this.account.fname} ${this.account.lname}`,
          employeeId: this.account.id,
          organizationId: this.account.organizationId,
        });

        posthog.capture('employee_logout', {
          employeeEmail: this.account.email,
          employeeName: `${this.account.fname} ${this.account.lname}`,
          employeeId: this.account.id,
          organizationId: this.account.organizationId,
          createdAt: new Date(),
        });

        // Best effort flush so the event is sent before reload/navigation
        try {
          await posthog.flush();
        } catch (e) {
          console.error('PostHog flush failed:', e);
        }
        this.$router.go();
      });
    },
  },
};
</script>
<style scoped>
.navbar {
  height: 3.5rem;
  background-color: #ffffff;
  border-bottom: 1px solid #e4e4e7;
  display: flex;
  align-items: center;
}

.navbar .organization-card {
  width: 80%;
  margin-left: 5%;
  padding: 0px;
  box-shadow: none;
  border-radius: 5px;
  margin-bottom: 0; /* Changed from 25px to 0 */
  border: 1px solid #FFFFFF;
}

.navbar .organization-card .card-body {
  padding: 9px 7px 5px 5px;
}

.navbar .organization-card .fa {
  font-size: 0.9rem;
  position: relative;
  bottom: 2px;
}

.navbar .organization-card .name {
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 240px;
}

.avatar {
  width: 2rem;
  height: 2rem;
  background-color: #ebebeb;
  border: 1px solid #e4e4e7;
  color: #2E7918;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1em;
  font-weight: bold;
  margin-right: 0;
}

.fa-caret-down {
  margin-left: 7px;
  color: #2E7918;
}

.avatar-caret-container {
  display: flex;
  align-items: center;
}

.navbar-right-section {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-left: auto;
  flex-shrink: 0;
}

.btn-help {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.82rem;
  font-weight: 500;
  color: #52525b;
  text-decoration: none;
  padding: 5px 10px;
  border-radius: 6px;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.btn-help:hover {
  background-color: #f4f4f5;
  color: #2E7918;
  text-decoration: none;
}

.btn-help .fa {
  font-size: 0.9rem;
  margin-right: 0;
}

.navbar > .row {
  flex-wrap: nowrap;
}

@media (max-width: 768px) {
  .btn-help span {
    display: none;
  }

  .navbar-right-section {
    gap: 8px;
  }
}
</style>
